module.exports = __webpack_public_path__ + "static/media/luc_logo.63b1292e.svg";